<script setup lang="ts">
import { reactive } from 'vue'

import Icon from '@/components/partials/Icon.vue'
import LoadingSpinner from '@/components/partials/Loading/LoadingSpinner.vue'

const state = reactive({
  loading: false,
})

const props = defineProps({
  loading: Boolean,
})
</script>

<template>
  <div
      data-test-id="geo-location-trigger"
      class="geo-location"
      :class="{ 'geo-location--loading': state.loading || props.loading }"
      tabindex="0"
  >
    <div
        class="geo-location-white"
        tabindex="0"
    >
      <LoadingSpinner
          v-if="state.loading || props.loading"
          class="location-search__loading-spinner"
          :size="16"
      />
      <Icon
          v-else
          name="pin-solid"
          class="geo-location-icon"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/variables/variables.scss";
@import "@/assets/css/mixins/breakpoints-up.scss";

.geo-location {
  $self:    &;
  position: absolute;
  top:      50%;
  left:     0.5rem;
  transform: translateY(-50%);
  cursor:   pointer;

  &-white {
    border-radius: 50%;
    position:      relative;
    z-index:       2;
    width:         3.2rem;
    height:        3.2rem;
    display:       flex;
    align-items:   center;
    justify-content: center;

    @include lg-up {
      width: 3.55rem;
      height: 3.55rem;
    }
  }

  &-icon {
    &:deep(path) {
      fill: $new-color-neutral-primary;
    }
  }

  &:focus,
  &:active {
    #{ $self }-white {
      background: #ffffff;
    }

    &::before {
      content:       "";
      width:         130%;
      height:        130%;
      background:    $new-gradient-brand-main;
      border-radius: 50%;
      position:      absolute;
      top:           50%;
      left:          50%;
      opacity:       0.2;
      transform:     translate(-50%, -50%);
      pointer-events: none;
      z-index:       0;
    }
  }
}
</style>
